export const SERVICE_CODE = 'DASHBOARD_OFFICE_MANAGER' + '_SERVICE';
